import React from "react";
import Layout from "../components/Layout";
import { useLanguage } from "../i18n/LanguageContext";
import "../styles/Contact.css";

function Contact() {
  const { t } = useLanguage();

  return (
    <Layout>
      <section className="panel contact-panel">
        <h1>{t.contact.title}</h1>
        <p>{t.contact.text}</p>
        <a href="mailto:kanan@frostwyrm.net" className="button">
          {t.contact.button}
        </a>
      </section>
    </Layout>
  );
}

export default Contact;
